// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3_c6t","productName":"Table_productName__1Vo6u"};